import { isVideoDialEnabled } from '../../../util/userUtil';
import { sessionUserSelector } from './sessionUserSelector';

import { createSelector } from 'reselect';

const isVideoDialEnabledSelector = createSelector(sessionUserSelector, ({ sessionUser }) => ({
  isVideoDialEnabled: isVideoDialEnabled(sessionUser)
}));
export { isVideoDialEnabledSelector };
